import { useTheme } from '@mui/material/styles';
import {LOGO, AUTH, FEATURES, ICON} from '../../../config/app-config';
// src/components/navigation/header/HeaderBar.js
import React, { useState } from 'react';
import {
    AppBar,
    Toolbar,
    IconButton,
    Box,
    Link,
    LinearProgress,
    Divider,
    Tooltip,
    useMediaQuery,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import '../../../index.css';
import Search from '../../search/Search';
import UserPortal from '../../user/UserPortal';
import ReleaseSelectors from './ReleaseSelectors';
import AccountMenu from './AccountMenu';
import BrandLogo from './BrandLogo';
import AdminDashboard from "../../admin/dashboard/Dashboard";

function HeaderBar({
    handleDrawerToggle,
    selectedRelease,
    setSelectedRelease,
    handleArticleSelect,
    fetchArticle,
    isLoading,
    offlineMode,
}) {
    const theme = useTheme();
    const darkMode = theme.palette.mode === 'dark';
    const isMobile = useMediaQuery(theme => theme.breakpoints.down('sm'));
    const [openUserPortal, setOpenUserPortal] = useState(false);
    const [openAdminDashboard, setOpenAdminDashboard] = useState(false);
    const handleOpenPortal = () => setOpenUserPortal(true);
    const handleClosePortal = () => setOpenUserPortal(false);
    const handleOpenAdminDashboard = () => setOpenAdminDashboard(true);
    const handleCloseAdminDashboard = () => setOpenAdminDashboard(false);

    const headerStyle = theme.brand.header;

    return (
        <>
            <AppBar
                position="fixed"
                sx={{
                    zIndex: theme => theme.zIndex.drawer + 1,
                    ...headerStyle,
                    height: { xs: 56, sm: 64 },
                }}
            >
                {isLoading && (
                    <LinearProgress
                        aria-label="Loading documentation"
                        sx={{ height: 3, width: '100%', position: 'absolute', top: 0 }}
                    />
                )}

                <Toolbar disableGutters sx={{ px: { xs: 1, sm: 2, md: 3 }, minHeight: { xs: 56, sm: 64 }, }}>
                    {/* 1) Left Side */}
                    <Box sx={{ display: 'flex', alignItems: 'center', flexShrink: 0 }}>
                        <Box sx={{display: { xs: 'block', sm: 'none' }}}>
                            <img src={ICON.favicon} alt="Product logo" style={{ width: 36, height: 36, marginRight: 8, marginLeft: 4, transform: 'translateY(5%)' }} />
                        </Box>

                        <Box
                            sx={{
                                display: { xs: 'none', sm: 'flex' },
                                flexDirection: 'column',
                                lineHeight: 1,
                                ml: -1
                            }}
                        >
                            {/* Environment-based logo link */}
                            <Tooltip title="Visit company website" arrow>
                                <Link href={LOGO.href} underline="none">

                                    <BrandLogo
                                        src={darkMode ? LOGO.dark : LOGO.light}
                                        alt={LOGO.alt}
                                        sx={{
                                            width: '100% !important',
                                            height: '55px',
                                            cursor: 'pointer',
                                            p: LOGO.padding,
                                        }}
                                    />
                                </Link>
                            </Tooltip>
                        </Box>
                    </Box>

                    {/* 2) Center (Search) */}
                    <Box
                        sx={{
                            flexGrow: 1,
                            minWidth: 0,
                            display: 'flex',
                            justifyContent: 'center',
                            px: { xs: 1, sm: 2 }
                        }}
                    >
                        <Box
                            sx={{
                                width: { xs: '100%', md: '90%', lg: '45%' },
                                maxWidth: 600
                            }}
                        >
                            <Search
                                selectedRelease={selectedRelease}
                                handleArticleSelect={handleArticleSelect}
                                fetchArticle={fetchArticle}
                                setSelectedRelease={setSelectedRelease}
                            />
                        </Box>
                    </Box>

                    {/* 3) Right Side */}
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            flexShrink: 0,
                            gap: { xs: 0, sm: 2 },
                        }}
                    >
                        {!isMobile && <ReleaseSelectors />}

                        {/* Only show login and divider when auth is enabled */}
                        {AUTH.enabled && FEATURES.account && !offlineMode && (
                            <>
                                <Divider
                                    orientation="vertical"
                                    flexItem
                                    sx={{
                                        display: { xs: 'none', sm: 'block' },
                                        mx: 1,
                                        bgcolor: theme => theme.palette.divider,
                                        width: '1px'
                                    }}
                                />

                                <AccountMenu
                                    offlineMode={offlineMode}
                                    onOpenPortal={handleOpenPortal}
                                    onOpenAdminDashboard={handleOpenAdminDashboard}
                                />
                            </>
                        )}

                        <IconButton
                            color="inherit"
                            aria-label="open drawer"
                            edge="start"
                            onClick={handleDrawerToggle}
                            sx={{ width: 48, height: 48, m: 0, display: { xs: 'inline-flex', sm: 'none' } }}
                        >

                            <MenuIcon sx={{ fontSize: 28 }} />
                        </IconButton>
                    </Box>
                </Toolbar>
            </AppBar>

            {/* UserPortal Dialog */}
            {FEATURES.collections && (
                <UserPortal
                    open={openUserPortal}
                    onClose={handleClosePortal}
                    fetchArticle={fetchArticle}
                />
            )}

            {/* Admin Dashboard Dialog */}
            {FEATURES.admin && (
                <AdminDashboard
                    open={openAdminDashboard}
                    onClose={handleCloseAdminDashboard}
                />
            )}
        </>
    );
}

export default HeaderBar;

